import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BlobFileApiModel } from '@app/api/api-models';
import { HttpClientService } from '@app/api/api-services/http-client.service';

@Injectable()
export class FormExportService {
  private readonly apiUrl = 'form-export';

  constructor(private readonly http: HttpClientService) {}

  public requestExport(idList: number[]): Observable<void> {
    return this.http.post<void>(`${this.apiUrl}/request`, idList);
  }
  public searchRequestExport(searchQuery: any): Observable<void> {
    return this.http.get<void>(`${this.apiUrl}/request-search`, { params: searchQuery });
  }

  public downloadExportResult(id: string): Observable<BlobFileApiModel> {
    return this.http
      .get<BlobFileApiModel>(`${this.apiUrl}/download/${id}`)
      .pipe(map((x) => new BlobFileApiModel().deserialize(x)));
  }
}
